import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  Flex,
  Icon,
  List,
  ListIcon,
  ListItem,
  Tag,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCheckCircle } from 'react-icons/ai';
import { HiSparkles } from 'react-icons/hi';

import { ISelectedPlanAddOn } from 'containers/AccountBilling/UpgradeBilling/UpgradeBilling';

import { IAddOn } from '../billingData';

interface IPlanAddOn extends IAddOn {
  headingStyles?: any;
  isChecked?: boolean;
  onChecked: (e: React.ChangeEvent<HTMLInputElement>, data: ISelectedPlanAddOn) => void;
}

const PlanAddOn: React.FC<IPlanAddOn> = ({
  id,
  heading,
  headingStyles,
  headingIcon,
  isNew = true,
  price,
  isYearly,
  descArray,
  isChecked,
  onChecked,
}) => {
  const { t } = useTranslation(['accountBilling', 'common']);
  return (
    <AccordionItem
      borderRadius="base"
      transition="all ease 0.5s"
      border="1px solid #d4d4d4"
      _hover={{
        borderColor: '#ACACAC',
      }}
      maxW={{ sm: '100%', md: '500px' }}
    >
      <Flex justifyContent="space-between">
        <AccordionButton
          borderRadius="base"
          _expanded={{
            bg: 'newBlue.100',
          }}
          sx={{
            borderColor: '#02020200',
          }}
        >
          <Flex w="100%" justifyContent="space-between" alignItems="center">
            <Checkbox
              isChecked={isChecked}
              onChange={e =>
                onChecked(e, { id: id, name: heading, price: isYearly ? +price.annually : +price.monthly })
              }
              borderColor="gray.400"
              colorScheme="secondary"
            >
              <Flex alignItems="center" gridGap={2}>
                <Icon as={headingIcon} sx={{ path: { fill: 'primary.500' } }} boxSize={{ sm: 4, md: 5 }} />
                <Text mb={0.5} fontSize={{ sm: 'md', md: 'lg' }} fontWeight={600} {...headingStyles}>
                  {heading}
                </Text>
                {isNew && (
                  <Tag
                    bg="secondary.50"
                    color="secondary.500"
                    fontWeight="bold"
                    w="fit-content"
                    display="flex"
                    gridGap={1}
                    alignItems="center"
                  >
                    {t('common:new')}
                    <HiSparkles />
                  </Tag>
                )}
              </Flex>
            </Checkbox>
          </Flex>
          <AccordionIcon />
        </AccordionButton>
      </Flex>
      <AccordionPanel pb={4} bg="white" borderRadius="0 0 4px 4px">
        <Text fontSize="md" mb={3} textAlign="center">
          <Text as="span" fontSize="xl" fontWeight="600">
            ${isYearly ? price.annually : price.monthly}
          </Text>
          {t('accountBilling:slashPerUser')}{' '}
          {isYearly ? t('accountBilling:billedAnnually') : t('accountBilling:billedMonthly')}!
        </Text>
        <List spacing={2}>
          {descArray.map((desc: string, index: number) => (
            <ListItem display="flex" alignContent="center" fontWeight={500} fontSize="sm" key={index}>
              <ListIcon as={AiFillCheckCircle} boxSize={6} color="secondary.500" />
              {desc}
            </ListItem>
          ))}
        </List>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default PlanAddOn;
